import map from "lodash/map";
import { v1 as uuid } from "uuid";
import { Unit } from "../../types/customization/box";
import {
  TemplateEditablePictureDefinition,
  TemplatePageDefinition,
} from "../../types/customization/template";
import { calcBleedingEdges } from "../../utils/customization/bleed";
import {
  calcAbsolutePosition,
  positionP10kToMm,
  sizeP10kToMm,
} from "../../utils/customization/box";

export function drawClippedPath(
  elementDefinition: TemplateEditablePictureDefinition,
  pageDefinition: TemplatePageDefinition,
  clippingSvg: string,
  showBleeding = false
): string {
  const elementSizeMm = sizeP10kToMm(elementDefinition, pageDefinition);
  const absolutePosition = calcAbsolutePosition<Unit.MM>({
    elementAnchor: elementDefinition.anchorSelf,
    elementPosition: positionP10kToMm(elementDefinition, pageDefinition),
    elementSize: elementSizeMm,
    pageAnchor: elementDefinition.anchorPage,
    pageSize: pageDefinition,
  });
  const bleedingEdges = calcBleedingEdges(elementDefinition, pageDefinition);

  const boxWidth = showBleeding
    ? elementSizeMm.width.value
    : elementSizeMm.width.value - bleedingEdges.left.value - bleedingEdges.right.value;
  const boxHeight = showBleeding
    ? elementSizeMm.height.value
    : elementSizeMm.height.value - bleedingEdges.top.value - bleedingEdges.bottom.value;
  const boxTop = absolutePosition.y.value + bleedingEdges.top.value;
  const boxLeft = absolutePosition.x.value + bleedingEdges.left.value;
  const bleedingBottom = showBleeding ? bleedingEdges.bottom.value : 0;
  const bleedingLeft = showBleeding ? bleedingEdges.left.value : 0;
  const bleedingRight = showBleeding ? bleedingEdges.right.value : 0;
  const bleedingTop = showBleeding ? bleedingEdges.top.value : 0;

  const pathId = uuid();

  const clipPaths = getClipPaths(clippingSvg);

  const svgClip = `
    <svg viewBox="0 0 ${boxWidth} ${boxHeight}">
      <clipPath id="testPathHexa-${pathId}" clipPathUnits="objectBoundingBox">
        ${clipPaths}
      </clipPath>
      <svg
        width="${pageDefinition.width.value}"
        height="${pageDefinition.height.value}"
        x="${bleedingLeft}"
        y="${bleedingTop}"
        viewBox="${boxLeft} ${boxTop} ${pageDefinition.width.value} ${pageDefinition.height.value}"
      >
        <g clip-path="url(#testPathHexa-${pathId})">
          ${clippingSvg}
          <rect
            x="${absolutePosition.x.value + bleedingLeft}"
            y="${absolutePosition.y.value + bleedingTop}"
            width="${elementSizeMm.width.value - bleedingLeft - bleedingRight}"
            height="${elementSizeMm.height.value - bleedingTop - bleedingBottom}"
            fill="#fff"
          />
        </g>
      </svg>
    </svg>`;
  return svgClip || "";
}

export function getClipPaths(clippingSvg: string): string {
  const container = document.createElement("div");
  container.innerHTML = clippingSvg.trim();
  const svgElement = container.firstChild as SVGSVGElement;
  const svgViewBox: string | null = svgElement ? svgElement.getAttribute("viewBox") : null;
  const svgViewBoxValues: string[] = svgViewBox ? svgViewBox.split(" ") : [];
  const svgRect = {
    height: parseInt(svgViewBoxValues[3], 10),
    width: parseInt(svgViewBoxValues[2], 10),
  };

  return svgElement
    ? map(svgElement.children, (item: SVGElement) => {
        item.setAttribute("transform", `scale(${1 / svgRect.width}, ${1 / svgRect.height})`);
        return item.outerHTML;
      }).join("")
    : "";
}
